module.exports = __webpack_public_path__ + "static/media/banner_chico.04999392.png";